import AdminModal from 'components/admin2/ui/AdminModal';
import styled from 'styled-components';

export const StyledAdminModal = styled(AdminModal)`
  overflow-y: hidden !important;
`;
